import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=46190c95&scoped=true&"
var script = {}
import style0 from "./Bottom.vue?vue&type=style&index=0&id=46190c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46190c95",
  null
  
)

export default component.exports